import Vue from 'vue';
import App from './App.vue';
import Auth from '_u/auth';
import router from './router';
import store from './store';
import plugin from '@/plugin';
import utils from '_u';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/common/index.less';

import axios from './api/http';
import api from './api';
import './utils/global';
import './utils/rem';
import './utils/readFile';
import Echarts from 'vue-echarts';
// import $ from 'jquery'
import 'echarts'; //全量引入echarts
import 'echarts-gl';
import scroll from 'vue-seamless-scroll';

Vue.component('v-chart', Echarts);
Vue.use(Auth); // 登录权限
Vue.use(plugin);
Vue.use(scroll);

Vue.prototype.$axios = axios;
Vue.prototype.$api = api;
Vue.prototype.$bus = new Vue();
Vue.prototype.$u = utils;
// Vue.prototype.$ = $
Vue.prototype.$apiHead = '/json';
Vue.prototype.$setInter = (fn) => {
  let timer = setInterval(() => {
    fn();
  }, 5000);
  return timer;
};
Vue.config.productionTip = false;
Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
